import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export default function PLHelp() {
    return (
        <IconTooltip>
            <div>
                A high-level overview of the Profit/Loss against the chosen
                benchmark (can be either Arrival, xVWAP or Last) set in the
                chart&apos;s configuration <Icon name="cog" />.
            </div>
        </IconTooltip>
    );
}
